import type React from 'react';

interface CardProps {
	stepLabel: string;
	title: string;
	description: string;
}

const Card = ({ stepLabel, title, description }: CardProps): React.JSX.Element => {
	return (
		<article className="h-full rounded-xl border border-border bg-card px-6 pt-6 pb-8 shadow-md transition duration-200 hover:border-primary/30 hover:shadow-lg">
			<p className="mb-3 text-sm font-bold uppercase tracking-[0.16em] text-primary">{stepLabel}</p>
			<h5 className="mb-3 text-lg font-bold leading-tight text-card-foreground">{title}</h5>
			<p className="mb-0 text-base leading-relaxed text-muted-foreground">{description}</p>
		</article>
	);
};

export default Card;
